import type { InviteDto } from "../../services/UserService.ts";
import type { InviteSummaryDto } from "../../services/InviteService.ts";
import type { Invite, InviteSummary } from "../../state/invite.ts";
import InviteId from "../../state/InviteId.ts";
import GroupId from "../../state/GroupId.ts";
import { toGrant } from "./grant.ts";

export const toInvite = (dto: InviteDto): Invite => ({
  id: InviteId.from(dto.id),
  emailAddress: dto.emailAddress,
  groups: dto.groups.map((groupId) => GroupId.from(groupId)),
  grants: dto.grants.filter(({ customerId }) => customerId >= 0).map(toGrant),
});

export const toInviteSummary = (dto: InviteSummaryDto): InviteSummary => ({
  id: InviteId.from(dto.id),
  customerId: dto.customerId,
  customerName: dto.customerName,
  emailAddress: dto.emailAddress,
  status: dto.status,
  language: dto.settings.language ?? "en",
});
